var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAdvantage5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5923 48.7743H21.3354C20.653 48.7743 20.0991 48.2204 20.0991 47.538C20.0991 46.8556 20.653 46.3018 21.3354 46.3018H46.5923C47.2747 46.3018 47.8286 46.8556 47.8286 47.538C47.8286 48.2204 47.2747 48.7743 46.5923 48.7743Z",
    fill: "#FFBDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0185 37.624L20.6724 42.867L25.8684 42.0894L21.0185 37.624Z",
    fill: "#FFBDCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6027 19.0519C40.9869 17.5634 38.4699 17.6673 36.9814 19.2831L21.8545 35.7106C21.878 35.7291 21.9015 35.7477 21.925 35.7687L27.5636 40.961C27.6143 41.008 27.6588 41.0587 27.6971 41.1118L42.8352 24.6732C44.3236 23.0574 44.2198 20.5404 42.604 19.0519H42.6027Z",
    fill: "#FFBDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdvantage5);
export default __webpack_public_path__ + "static/media/ico_advantage5.91a33be7597ca4a606fd38cc9e0a3bf6.svg";
export { ForwardRef as ReactComponent };